export enum ManufacturerListFormValue {
  DESCRIPTION = 'Description',
}
